import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { StonePricingPage, stonePriceRulesQueryOptions } from '@/features/dictionary';

export const Route = createFileRoute('/_authed/_active/org/stone-pricing')({
  staticData: { crumb: 'common:nav.stonePricing', tours: ['dictionary.stone-pricing'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'configurator.read');
  },
  loader: ({ context }) =>
    context.queryClient
      .query({ ...stonePriceRulesQueryOptions(), staleTime: 'static' })
      .catch(() => undefined),
  component: StonePricingPage,
});
